import script from "./ViewModeSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewModeSwitcher.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__